<template>
    <div 
        v-html=htmlCode
        class="appup-html">
    </div>
</template>

<script>
/**
 * Component to display HTML content that is provided
 * 
 */
export default {
    name: 'app-html',
    props: {
        /** 
         * Content to be displayed
         */
        content: {
            type:String,
            required:true
        }
    },
    data: function() {
        return {
            htmlCode : this.content
        }
    },
    created() {
    },
    methods: {
    }
};
</script>


// WEBPACK FOOTER //
// src/components/html/html.vue